
import { defineComponent, useAsync, useMeta } from "@nuxtjs/composition-api";

export default defineComponent({
  setup() {
    useAsync(() => {
      const { link } = useMeta();

      link.value.push({
        rel: "preload",
        href: `/videos/home/brands/posters/xs.webp`,
        type: "image/webp",
        as: "image",
        media: "(max-width: 599px)",
      });
    }, "shop-brands-video-preload");

    const brands = [
      "bergdorf",
      "revolve",
      "wayfair",
      "sephora",
      "bar",
      "abercrombie",
      "target",
      "gucci",
      "dibs",
      "tecovas",
      "aritzia",
      "anthropologie",
    ] as const;

    return {
      brands,
    };
  },
  head: {},
});
